<template>
  <li class="m-tagItem">
    <slot>タグ名がありません</slot>
  </li>
</template>

<script>

export default {
  // props: ['type'],
  mounted () {
  }
}
</script>

<style lang="scss">
.m-tagItem {
  display: inline-block;
  padding: .5em .8em .5em .5em;
  margin: .2em .2em;
  border-radius: 50px;
  box-shadow: 0 0 0 2px #999 inset;
  color: #666;
  font-size: .6em;
  line-height: 1;
  &[style] {
    border: 0;
    box-shadow: none;
    color: #fff;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// Tag.vue?0f4a5a3e